import React, { useState } from 'react';
import { Linkedin, Github, Menu, X } from 'lucide-react';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';

// --- Main App Component ---
export default function App() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [, setActiveSection] = useState('home');

    const navLinks = [
        { href: 'home', label: 'Home' },
        { href: 'about', label: 'About' },
        { href: 'skills', label: 'Skills' },
        { href: 'projects', label: 'Projects' },
        { href: 'education', label: 'Education' },
        { href: 'contact', label: 'Contact' },
    ];

    const handleNavClick = (section) => {
        setActiveSection(section);
        setIsMenuOpen(false);
        document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="bg-gray-900 text-gray-100 font-sans antialiased">
            <Header navLinks={navLinks} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} handleNavClick={handleNavClick} />
            <main className="pt-20">
                <Home handleNavClick={handleNavClick} />
                <About id="about" />
                <Skills id="skills" />
                <Projects id="projects" />
                <Education id="education" />
                <Contact id="contact" />
            </main>
            <Footer />
        </div>
    );
}

// --- Header Component ---
const Header = ({ navLinks, isMenuOpen, setIsMenuOpen, handleNavClick }) => {
    return (
        <header className="fixed top-0 left-0 right-0 bg-gray-900 bg-opacity-80 backdrop-blur-md z-50 shadow-lg">
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <a href="#home" onClick={() => handleNavClick('home')} className="text-2xl font-bold text-cyan-400 hover:text-cyan-300 transition-colors">
                    {/* Rajan Bhalodiya */}
                    RB
                </a>
                <nav className="hidden md:flex space-x-6">
                    {navLinks.map((link) => (
                        <a
                            key={link.href}
                            href={`#${link.href}`}
                            onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                            className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 font-medium"
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>
                <div className="md:hidden">
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-300 hover:text-cyan-400 focus:outline-none">
                        {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                    </button>
                </div>
            </div>
            {isMenuOpen && (
                <div className="md:hidden bg-gray-800">
                    <nav className="flex flex-col items-center px-6 pt-2 pb-4 space-y-3">
                        {navLinks.map((link) => (
                            <a
                                key={link.href}
                                href={`#${link.href}`}
                                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                                className="block w-full text-center py-2 text-gray-300 hover:text-cyan-400 hover:bg-gray-700 rounded-md transition-colors duration-300"
                            >
                                {link.label}
                            </a>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
};



// --- Footer Component ---
const Footer = () => (
    <footer className="bg-gray-800 py-8">
        <div className="container mx-auto px-6 text-center text-gray-400">
            <div className="flex justify-center space-x-6 mb-4">
                <a href="https://github.com/Rajanbhalodiya" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                    <Github size={28} />
                </a>
                <a href="https://www.linkedin.com/in/rajan-bhalodiya-839695264" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                    <Linkedin size={28} />
                </a>
            </div>
            <p>&copy; {new Date().getFullYear()} Rajan Bhalodiya. All Rights Reserved.</p>
        </div>
    </footer>
);
